import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gt-object-card" }
const _hoisted_2 = { class: "gt-object-card__head gt-space_mb gt-space_mb--4" }
const _hoisted_3 = { class: "gt-object-card__select-btn" }
const _hoisted_4 = { class: "gt-object-card__body" }
const _hoisted_5 = { class: "gt-object-card__id gt-space_mb gt-space_mb--3" }
const _hoisted_6 = { class: "gt-object-card__name gt-space_mb gt-space_mb--3" }
const _hoisted_7 = { class: "gt-object-card__info" }
const _hoisted_8 = { class: "gt-object-card__company gt-space_mb gt-space_mb--3" }
const _hoisted_9 = { class: "gt-object-card__icon gt-space_mr gt-space_mr--2" }
const _hoisted_10 = { class: "gt-object-card__company" }
const _hoisted_11 = { class: "gt-object-card__bottom gt-space_mt gt-space_mt--3" }
const _hoisted_12 = { class: "gt-object-card__sellers" }
const _hoisted_13 = { class: "gt-space_mr gt-space_mr--2" }
const _hoisted_14 = { class: "gt-object-card__buttons" }
const _hoisted_15 = { class: "gt-object-card__icon gt-space_ml gt-space_ml--2" }
const _hoisted_16 = { class: "gt-object-card__icon gt-space_ml gt-space_ml--2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i_pin_small = _resolveComponent("i-pin-small")!
  const _component_i_users = _resolveComponent("i-users")!
  const _component_i_edit = _resolveComponent("i-edit")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_i_arrow_right = _resolveComponent("i-arrow-right")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "select")
      ]),
      _createElementVNode("div", {
        class: "gt-object-card__status",
        style: _normalizeStyle({ backgroundColor: $setup.USER_STATUS_COLOR_MAP[$props.outlet.isActive ? 1 : 2].color })
      }, [
        _createElementVNode("span", null, _toDisplayString($props.outlet.isActive ? $setup.$t('Active') : $setup.$t('Inactive')), 1)
      ], 4)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", _hoisted_5, _toDisplayString($setup.externalId), 1),
      _createElementVNode("p", _hoisted_6, _toDisplayString($setup.title), 1),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_i_pin_small)
          ]),
          _createElementVNode("span", null, _toDisplayString($setup.group.title), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", null, _toDisplayString($setup.address), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_i_users)
        ]),
        _createElementVNode("span", null, _toDisplayString($setup.sellers), 1)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_router_link, {
          class: "gt-object-card__more-btn ds-link gt-space_mr gt-space_mr--5",
          to: { name: $setup.OUTLET_UPDATE_PAGE_NAME, params: { id: $setup.id } }
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString($setup.$t('Edit')), 1),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_i_edit)
            ])
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_router_link, {
          class: "gt-object-card__more-btn ds-link",
          to: { name: $setup.OUTLET_DETAILS_PAGE_NAME, params: { id: $setup.id } }
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString($setup.$t('Details')), 1),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_i_arrow_right)
            ])
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}